import * as React from 'react';
import { useParams } from 'react-router-dom';
import { loader } from '../../Func_genericas/loader';
import { imagens } from '../../Func_genericas/valores_estaticos';
import { get_token_agricultor } from '../../Hook/useApi';
import { IconButton, InputAdornment, Snackbar, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Alert } from '../../Components/Alert/Alert';
import { func_print } from '../../Func_genericas/func_print';
import { get_login, post_login } from '../../Services/tokenConfig';
import { Preenchercodigo } from './Preenchercodigo';
import { AuthContext } from '../../AuthContext/AuthContext';

export default function LoginAgricultor() {
  const { orgId } = useParams<{ orgId?: string }>();
  const auth = React.useContext(AuthContext);

  const [org_nome, set_org_nome] = React.useState<string>('');
  const [msg_aviso, set_msg_aviso] = React.useState<string>('');
  const [username, set_username] = React.useState<string>('');
  const [password, set_password] = React.useState<string | undefined>('');

  // orgId no URL é o UUID da org (gerado autenticado em definicoesTecnico)
  // chamada pública sem token para buscar o nome
  React.useEffect(() => {
    auth.signout();


    if (!orgId) return;

    get_login('', `/org_nome/${orgId}`)
      .then((res) => {
        if (res.status === 200) {
          const nome =
            res.data?.nome ??
            res.data?.result?.nome ??
            res.data?.result?.name ??
            res.data?.result ??
            '';
          set_org_nome(String(nome));
        }
      })
      .catch((err) => func_print('org_nome fetch', err, true));
  }, [orgId]);

  const [open_modal_aviso, set_open_modal_aviso] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [open_code_insert, set_open_code_insert] = React.useState<boolean>(false);
  const [open_modal_recuperar_password, set_open_modal_recuperar_password] = React.useState<boolean>(false);
  const [mostrar_password, set_mostrar_password] = React.useState(false);

  const submitLogin = async () => {
    setIsLoading(true);
    try {
      if (username !== undefined && password !== undefined) {
        let aux_obj = {
          email: username === undefined ? '' : username,
          password: password === undefined ? '' : password,
          secret_2fa: null,
        };

        let res: any = await get_token_agricultor({ payload: aux_obj });

        if (res.flag === false) {
          const msg =
            typeof res.error === "string"
              ? res.error
              : res.error != null
                ? String(res.error)
                : typeof res.data === "string"
                  ? res.data
                  : "Erro ao iniciar sessão.";
          set_msg_aviso(msg);
          set_open_modal_aviso(true);
        } else {
          set_open_code_insert(true);
        }
      }
      setIsLoading(false);
    } catch (error: any) {
      set_msg_aviso(error);
      set_open_modal_aviso(true);
      setIsLoading(false);
    }
  };

  const handle_recuperar_password = async () => {
    try {
      setIsLoading(true);
      let data = await post_login('', 'reset_password', {
        payload: {
          email: username,
          secret_2fa: null,
        },
      });
      if (data.status === 200) {
        set_password(undefined);
        set_open_code_insert(true);
        set_open_modal_recuperar_password(false);
      } else {
        set_msg_aviso('Erro ao efetuar a sua operação!');
        set_open_modal_aviso(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print('handle_recuperar_password', error, true);
      setIsLoading(false);
      set_msg_aviso('Erro ao efetuar a sua operação!');
      set_open_modal_aviso(true);
    }
  };

  if (open_code_insert) {
    return (
      <Preenchercodigo
        set_open_code_insert={set_open_code_insert}
        email={username}
        password={password}
      />
    );
  }

  if (isLoading) return loader();



  return (
    <>
      <Snackbar
        open={open_modal_aviso}
        autoHideDuration={2000}
        onClose={() => set_open_modal_aviso(false)}
      >
        <Alert onClose={() => set_open_modal_aviso(false)} severity="error" sx={{ width: '100%' }}>
          {msg_aviso}
        </Alert>
      </Snackbar>

      {open_modal_recuperar_password && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="relative w-full max-w-md rounded-2xl bg-white p-8 shadow-sm">
            <button
              type="button"
              onClick={() => set_open_modal_recuperar_password(false)}
              className="absolute right-4 top-4 p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
            <h3 className="mb-2 text-xl font-bold text-gray-800">Recuperar palavra-passe</h3>
            <p className="mb-6 text-sm text-gray-500">
              Insira o seu email para receber um código de recuperação.
            </p>
            <TextField
              variant="outlined"
              fullWidth
              type="email"
              label="Email"
              placeholder="O seu email"
              value={username}
              onChange={(e) => set_username(e.target.value)}
              margin="normal"
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
            <button
              type="button"
              onClick={handle_recuperar_password}
              className="mt-5 w-full inline-flex items-center justify-center px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer shadow-none"
            >
              Enviar código
            </button>
          </div>
        </div>
      )}

      <div className="grid h-[100dvh] w-full min-w-0 grid-cols-1 overflow-hidden md:grid-cols-2">
        <div className="hidden min-h-0 min-w-0 flex-col items-center justify-center bg-[#C94F1E] px-12 py-8 md:flex md:px-20 md:py-10 lg:px-24">
          <div className="flex w-full max-w-lg flex-col items-center gap-10 text-center">
            <div className="min-w-0">
              <h1 className="text-6xl font-extrabold tracking-tight text-white">
                VULPES <span className="font-light text-white/70">Agricultores</span>
              </h1>
              <p className="mt-4 text-sm leading-relaxed text-white">
                Inteligente e versátil, Vulpes fornece ferramentas de gestão das suas atividades agrícolas,
                otimização de recursos, permitindo tomar as melhores decisões estratégicas obtendo uma
                produção agrícola eficiente e sustentável.
              </p>
            </div>
            <div className="flex flex-col items-center gap-4">
              <img
                src={imagens.logo_login}
                alt="Vulpes logo"
                className="w-48 opacity-90 drop-shadow-xl"
              />
              <button
                type="button"
                onClick={() => window.open('https://2gfinnovationsystems.pt/')}
                className="bg-transparent border-none text-xs text-white/60 underline underline-offset-2 hover:text-white/90 transition-colors cursor-pointer"
              >
                Desenvolvido por 2GF Innovation Systems
              </button>
            </div>
          </div>
        </div>

        <div className="flex min-h-0 min-w-0 flex-col items-center justify-center bg-white p-8 md:p-10">
          <div className="mb-8 flex flex-col items-center md:hidden">
            <h1 className="text-4xl font-extrabold text-[#C94F1E]">
              VULPES <span className="font-light text-gray-400">Agricultores</span>
            </h1>
          </div>

          <div className="w-full max-w-sm">
            <h2 className={`text-3xl font-bold text-gray-800 ${org_nome ? 'mb-0' : 'mb-4'}`}>Bem-vindo!</h2>
            {org_nome ? (
              <p className="mb-5 w-full rounded-lg border border-[#C94F1E]/25 bg-[#C94F1E]/8 text-left text-2xl font-extrabold leading-tight tracking-tight text-[#C94F1E] md:text-3xl lg:text-4xl">
                {org_nome}
              </p>
            ) : null}

            <div className="flex flex-col gap-0">
              <TextField
                variant="outlined"
                fullWidth
                type="email"
                label="Email"
                placeholder="email@exemplo.pt"
                value={username}
                onChange={(e) => set_username(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && submitLogin()}
                margin="normal"
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
              <TextField
                variant="outlined"
                fullWidth
                type={mostrar_password ? 'text' : 'password'}
                label="Palavra-passe"
                placeholder="••••••••"
                value={password ?? ''}
                onChange={(e) => set_password(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && submitLogin()}
                margin="normal"
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        aria-label={mostrar_password ? 'ocultar palavra-passe' : 'mostrar palavra-passe'}
                        onClick={() => set_mostrar_password((v) => !v)}
                        edge="end"
                      >
                        {mostrar_password ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div className="mt-3 flex justify-end">
              <button
                onClick={() => set_open_modal_recuperar_password(true)}
                className="text-xs text-[#C94F1E] hover:underline bg-transparent border-none cursor-pointer"
              >
                Esqueceu-se da palavra-passe?
              </button>
            </div>

            <button
              type="button"
              onClick={submitLogin}
              className="mt-6 w-full inline-flex items-center justify-center px-5 py-4 rounded-xl font-bold text-lg text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer shadow-none"
            >
              Iniciar Sessão
            </button>

            <p className="mt-6 text-center text-xs leading-relaxed text-gray-400">
              Ao iniciar sessão declara que concorda com as nossas{' '}
              <a
                href="https://2gfinnovationsystems.pt/politica-privacidade.html"
                target="_blank"
                rel="noopener noreferrer"
                className="font-normal text-gray-400 underline underline-offset-2"
              >
                Política de Privacidade
              </a>
              {' '}e{' '}
              <a
                href="https://2gfinnovationsystems.pt/politica-cookies.html"
                target="_blank"
                rel="noopener noreferrer"
                className="font-normal text-gray-400 underline underline-offset-2"
              >
                Política de Cookies
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
